import * as SurveyCore from 'survey-core';
import * as SurveyReact from 'survey-react-ui';
import 'survey-core/survey.i18n.js';
import 'survey-core/defaultV2.css';
import { useDispatch } from 'react-redux';
import { useMount } from 'react-use';

import { getSurveyLocalize } from 'utils/Survey';
import { clearSurveyJs, setSurveyJs } from 'store/patient/reducer';
import { useAppSelector } from 'hooks';

interface ISurveyJSProps {
  survey: ISurveyJS;
  handleComplete: any;
  useCustomCss?: boolean;
}

const SurveyJS = ({ survey, handleComplete, useCustomCss = false }: ISurveyJSProps) => {
  survey.surveyId = undefined; // remove surveyjs public api call getSurvey
  const surveyLocalized = getSurveyLocalize(survey);
  const locale = useAppSelector((state) => state.intl.locale);
  const surveyState = useAppSelector((state) => state.patient.inProgress.surveyjs);
  const dispatch = useDispatch();

  SurveyCore.StylesManager.applyTheme('defaultV2');
  SurveyCore.surveyLocalization.currentLocale = locale;
  const SurveyModel = new SurveyCore.Model(surveyState || surveyLocalized);
  SurveyModel.textUpdateMode = 'onTyping';

  SurveyModel.onComplete.add((survey: any) => {
    handleComplete(survey.data);
  });

  SurveyModel.onCurrentPageChanged.add((survey: any) => {
    dispatch(setSurveyJs(survey));
  });

  SurveyModel.onValueChanged.add((survey: any) => {
    dispatch(setSurveyJs(survey));
  });

  if (useCustomCss) {
    const customCss = {
      container: 'survey-blue-bg',
      actionBar: {
        root: 'd-flex justify-content-center'
      },
      navigationButton: 'survey-btn'
    };

    SurveyModel.css = customCss;
  }

  useMount(() => {
    dispatch(clearSurveyJs());
  });

  return <SurveyReact.Survey model={surveyState || SurveyModel} />;
};

export default SurveyJS;
